export default {
  'LandingCollaboratorsSection.inCollaborationWith': {
    en: 'IN COLLABORATION WITH',
    fr: 'EN COLLABORATION AVEC',
  },
};
